import React from "react";

/**
 * What renders in place of an organism that threw. Server Component, no
 * dependencies — an error path must not be able to fail for a second reason.
 *
 * ⚠ Not `app/components/error-boundary/dds-error-display`: that one is
 * `"use client"` and lazily imports `@directv-digital/dds.ui.error-display`,
 * so reusing it would pull both a client boundary and a Bit package into
 * every v3 page. v3 ships neither.
 */

const CUSTOMER_MESSAGE =
  "Some content isn't available right now. Refresh the page or try again later.";

export interface OrganismErrorProps {
  /** Blok type, shown only outside production. */
  type: string;
  /** Surfaced only outside production — never to a customer. */
  detail?: string;
}

export function OrganismError({ type, detail }: OrganismErrorProps) {
  const showDetail = process.env.NODE_ENV !== "production";

  return (
    <div
      role="alert"
      style={{
        padding: "var(--spacing-20, 1.25rem)",
        color: "var(--color-text-default, #f2f5fa)"
      }}
    >
      <p style={{ margin: 0 }}>{CUSTOMER_MESSAGE}</p>
      {showDetail && (
        <pre
          style={{
            margin: "8px 0 0",
            fontSize: 12,
            whiteSpace: "pre-wrap",
            opacity: 0.7
          }}
        >
          {type}
          {detail ? `: ${detail}` : ""}
        </pre>
      )}
    </div>
  );
}

export default OrganismError;
